// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'align-right';

export const Component = () => (
  <path d='M12.011 3.43c-.326 0-.465-.14-.465-.465s.14-.465.465-.465h10.477c.326 0 .512.14.512.465 0 .326-.186.465-.512.465H12.011Zm10.477 3.814H2.466c-.326 0-.466.185-.466.51 0 .326.14.466.466.466h20.022c.326 0 .512-.14.512-.465 0-.326-.186-.511-.512-.511Zm0 4.79H12.011c-.326 0-.465.14-.465.466 0 .325.14.465.465.465h10.477c.326 0 .512-.14.512-.465s-.186-.465-.512-.465Zm0 4.744H2.466c-.326 0-.466.14-.466.466 0 .325.14.51.466.51h20.022c.326 0 .512-.185.512-.51 0-.326-.186-.466-.512-.466Zm0 4.792H12.011c-.326 0-.465.14-.465.465s.14.465.465.465h10.477c.326 0 .512-.14.512-.465 0-.326-.186-.465-.512-.465Z' />
);

export const viewBox = '0 0 25 25';
